export default {
    // HOME
    "Mes moments-clés": "Mijn belangrijkste momenten",
    "Mes documents": "Mijn documenten",
    "Mes paiements": "Mijn betalingen",
    "Mes livraisons": "Mijn leveringen",
    "Conciergerie / Location": "Conciergerie / Verhuur",

    // SIDEBAR
    "Déconnexion": "Uitloggen",
    "Mon projet": "Mijn project",
    "Mon profil": "Mijn profiel",
    "Parrainage": "Partners",

    // PROJET
    "Aucun projet pour l'instant": "Geen project beschikbaar op dit moment",

    // PROFIL
    "Modifier mon profil": "Mijn profiel bewerken",
    "Prénom": "Voornaam",
    "Nom": "Naam",
    "Mot de passe": "Wachtwoord",
    "NIE": "NIE",
    "Adresse": "Adres",
    "Code postal": "Postcode",
    "Ville": "Stad",
    "Pays": "Land",
    "Téléphone": "Telefoon",
    "Mobile": "GSM",
    "Enregistrer": "Opslaan",
    "Votre profil a bien été enregistré": "Uw profiel is opgeslagen",

    // PARRAINAGE
    'SPONSORSHIP_TEXT': "\
        <p>Wij ondervinden reeds enkele jaren dat steeds meer en meer Secundo klanten ontstaan dankzij de mond tot mond reclame.</p>\
        <p>Veel tevreden klanten praten over ons met de mensen om hen heen, zodat deze een beroep kunnen doen op onze diensten.</p>\
        <p>We besloten ze te bedanken door een cheque van 250 € aan te bieden voor vliegtickets per klant die werd verzonden om bij de Secundo-familie te komen.</p>\
        <p>Om dit te doen, niets eenvoudiger dan dat, u geeft ons de contactgegevens van je contactpersonen door op de formulierknop te klikken, nadat zij hun schriftelijke toestemming hebben gegeven dat je ons hun naam geeft.</p>\
        <p>Deze contacten zullen uiteraard niet worden doorgegeven aan derden.</p>\
        <p>Bedankt voor uw medewerking.</p>\
    ",
    "Formulaire": "Formulier",
    "Titre": "Aanspreektitel",
    "Monsieur": "Dhr",
    "Madame": "Mevr",
    "Nom de l'ami": "Naam van vriend",
    "Prénom de l'ami": "Voornaam van vriend",
    "Email de l'ami": "Email van vriend",
    "Téléphone de l'ami": "Telefoon van vriend",
    "Envoyer": "Verzenden",
    "Parrainage enregistré !": "Uw peterschap werd geregistreerd !",

    // TAB BAR
    "Carte VIP": "VIP Kaart",
    "Urgences": "Noodgevallen",

    // MOMENTS CLE
    "Aujourd'hui": "Vandaag",
    "Indéterminée": "Onbepaald",
    "RDV avocat": "Advocaat afspraak",
    "RDV Fournisseurs": "Leveranciers afspraak",
    "RDV état des lieux": "Plaatsbeschrijving afspraak",
    "RDV check": "Check afspraak",
    "RDV Info": "Informatie afspraak",
    "RDV Choix matériaux": "Materiaalkeuze afspraak",
    "Remise des clefs": "Afgifte van de sleutels",

    // MES DOCUMENTS
    "Numéro d'identification d'étranger": "Nationaal Nummer voor Buitenlanders",
    "Choix de matériaux": "Keuzes van materialen",
    "Mes commandes matériaux & Extra": "Mijn keuzes van materialen & Extra",
    "Mes fournitures": "Mijn benodigdheden",
    "Contrats d'achat": "Aankoopcontracten",

    // MES PAIEMENTS
    "Paiement du bien": "Betaling van de woning",
    "Paiement des fournitures": "Betaling van benodigdheden",
    "Montant": "Bedrag",
    "Payé": "Betaald",
    "Acompte": "Vooruitbetaling",
    "Solde": "Saldo",
    "Arrhes": "Reserveringsbedrag",
    "Acompte 1": "Vooruitbetaling 1",
    "Acompte 2": "Vooruitbetaling 2",
    "Acompte 3": "Vooruitbetaling 3",

    // MES LIVRAISONS
    "Date prévue": "Geplande datum",
    "Statut": "Status",
    "Pas encore de livraison": "Nog niet geleverd",

    // KEYHOLDING
    "Brochures": "Brochures",

    // CARTE VIP
    "Aucun partner pour l'instant": "Aucun partner pour l'instant",
    "Activité": "Activiteit",
    "Avantage Secundo": "Secundo Voordeel",
    "Personne de contact": "Contactpersoon",

    // CONTACT
    "Belgique - France": "België - Frankrijk",

    // URGENCES
    "Numéros d'urgences": "Noodnummers",
    "Police": "Politie",
    "Urgence générale": "Algemene noodgeval",
    "Police": "Politie",
    "Ambulance, médecins": "Ziekenwagen, dokters",
    "Pompiers": "Pompiers",
    "Centre antipoison": "Antigifcentrum",
}


// WEBPACK FOOTER //
// ./src/data/translations/nl.js